import React, { useEffect, useState } from 'react';
import './UpdatePhoneView.scss';
import checkMark from '../../../gif/check-mark.gif';
import checkMarkImage from '../../../gif/check-mark.png';

const ANIMATION_STATE = {
  NOT_STARTED: 'not-started',
  ANIMATING: 'animating',
  FINISHED: 'finished',
};

const UpdateSuccess = () => {
  const [animationState, setAnimationState] = useState(ANIMATION_STATE.NOT_STARTED);

  useEffect(() => {
    setTimeout(() => {
      setAnimationState(ANIMATION_STATE.ANIMATING);
    }, [500]);

    setTimeout(() => {
      setAnimationState(ANIMATION_STATE.FINISHED);
    }, [2000]);
  }, []);

  return (
    <div className="UpdateSuccess">
      {animationState === ANIMATION_STATE.ANIMATING && <img className="UpdateSuccess__animationContainer" src={checkMark} alt="Verification completed" />}
      {animationState === ANIMATION_STATE.FINISHED && <img className="UpdateSuccess__animationContainer" src={checkMarkImage} alt="Verification completed" />}
    </div>
  );
};

export default UpdateSuccess;
